<template>
  <div class="container-page">
    <div>
      <p class="title-inner">Карточка цели проекта</p>
    </div>

    <div>
      <div class="row">
        <div class="col-12">
          <div class="form-group required">
            <ComponentInput
              v-model="item.name"
              label="Наименование"
              required
              maxLength="250"
              placeholder="Введите наименование"
            />
          </div>
        </div>
      </div>
      <div class="row mt-10">
        <CheckboxInput v-model="item.isActive" label="Запись активна" />
      </div>
    </div>

    <div>
      <ButtonComponent mod="gradient-bg" class="mr-8" @click="save">Сохранить</ButtonComponent>
      <ButtonComponent mod="gradient-bg" @click="close">Отмена</ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import Constants from '@/common/constants';

  import API from '../api/nsi';

  export default {
    name: 'ProjectPurposeCard',
    components: { CheckboxInput, ComponentInput, ButtonComponent },
    data() {
      return {
        id: this.$route.params.id,
        item: {},
        apiRoute: 'MpkProjectPurpose',
        cardName: 'ProjectPurposeCard',
        listName: 'ProjectPurposes',
      };
    },
    created() {
      this.loadCard();
    },
    methods: {
      loadCard() {
        if (this.id > 0) {
          API.find(this.apiRoute, this.id).then((response) => {
            this.item = response.data;
          });
        } else {
          this.item = {
            isActive: true,
          };
        }
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        API.update(this.apiRoute, this.item)
          .then((response) => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            if (response && response.data.id) {
              this.$router.push({ name: this.cardName, params: { id: response.data.id, action: 'edit' } });
            }
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      close() {
        this.$router.push({ name: this.listName });
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        item: {},
      };
    },
  };
</script>

<style lang="scss" scoped></style>
